//
import { HttpEvent, HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { inject } from '@angular/core';
import { SpinnerService } from '../services/spinner.service';

// Move this outside so it's not recreated per request
const IGNORED_ENDPOINTS = [
  'mondee/airport-list',
  'mondee/city-list',
  '/chatbot',
  'reservations/customer-type-list',
  'reservations/available-rooms',
  'employee-shift/shift-info',
  'attendance/employee/mark-present',
  'checkout/housekeeping-insight',
  'security-deposit/refund-settle',
  'reservations/vacant-rooms'
];

// Helper function
const isIgnoredRequest = (url: string): boolean =>
  IGNORED_ENDPOINTS.some(endpoint => url.includes(endpoint));

export const spinnerInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {

  const spinnerService = inject(SpinnerService);

  const hasSkipLoaderHeader = req.headers.get('X-Skip-Loader') === 'true';

  const request = hasSkipLoaderHeader
    ? req.clone({ headers: req.headers.delete('X-Skip-Loader') })
    : req;

  const shouldSkipSpinner =
    hasSkipLoaderHeader || isIgnoredRequest(request.url);

  // Show spinner
  if (!shouldSkipSpinner) {
    spinnerService.show();
  }

  return next(request).pipe(
    catchError((error) => {
      console.error('HTTP request error:', error);
      return throwError(() => error); // better RxJS practice
    }),
    finalize(() => {
      if (!shouldSkipSpinner) {
        spinnerService.hide();
      }
    })
  );
};
